/**
 * @fileoverview non-AI data fetch utilities for solarIQ
 * 
 * handles bill retrieval, system status check feature, modal auth, etc.
 * returns data|null - components handle state/toasts
 */

import { apiHeaders } from "./apiConfig.js";

/**
 * fetchBill:
 * retrieves bill images for a lead from db
 * 
 * @param {string} leadID
 * 
 * @returns {Promise<Array|null>} - array of bill objs or null if nothing found/failure
 */
export async function fetchBill(leadID) {
    const token = sessionStorage.getItem("solariq_token");
    try {
        const res = await fetch(`/bill?id=${leadID}`, {
            headers: {
                "Content-Type": "application/json",
                ...(token ? {Authorization: `Bearer ${token}` } : {}),
            }
        });
        if (!res.ok) {
            console.error("fetchBill failed.");
            return null;
        }
        return await res.json();
    
    } catch {
        console.error("fetchBill error");
        return null;
    }   
}

/**
 * checkStatus:
 * checks server and blob storage health
 * returns error shape (not null) on failure - component displays error details
 * 
 * @returns {Promise<Object>} - status object | error shape
 */
export async function checkStatus() {
    try {
        const res = await fetch("/status");
        return await res.json();
    } catch (e) {
        return { blobs: false, error: e.message, leads: 0, bills: 0 };
    }
}

/**
 * verifyResetPassword:
 * sends password reset request to auth function
 * caller inspects res.ok and status
 * 
 * @param {string} password
 * 
 * @returns {Promise<Response|null>} - raw response
 */
export async function verifyResetPassword(password) {
    try {
        return await fetch("/auth", {
            method: "POST",
            headers: apiHeaders(),
            body: JSON.stringify({ role: "reset", password }),
        });
    } catch {
        console.error("verifyResetPassword failed");
        return null;
    }
}
